const BeginPhaseExecutionComponent = () => {
  return <></>;
};
export default BeginPhaseExecutionComponent;
